import React from 'react';
import { FormControl } from 'react-bootstrap';
import AppModal from '../../../../common/AppModal';

const ClosingChangeRequestModal = ({ show, onHide, values, onValuesChange, onSubmit, submittingChangeRequest, subheading}) => {
  return (
    <AppModal
      show={show}
      onHide={onHide}
      onSubmit={onSubmit}
      heading="Confirm Closing Date Change"
      subheading={subheading}
      submitting={submittingChangeRequest}
      submitLabel="Submit"
    >
        <h6 className="modal-form-label">Notes</h6>
        <FormControl
          className="app-modal-notes-input mt-0"
          as="textarea"
          value={values?.changeNotes || ''}
          onChange={e => onValuesChange('changeNotes', e.target.value)}
          placeholder="Add a reason or any context for this closing date change..."
          size="sm"
          rows={3}
          disabled={submittingChangeRequest}
        />

        <h6 className="mt-3 modal-form-label">Closing Date</h6>
        <FormControl
          className="app-modal-field-input mt-0"
          type="date"
          value={values?.newClosingDate || ''}
          onChange={e => onValuesChange('newClosingDate', e.target.value)}
          size="sm"
          disabled={submittingChangeRequest}
        />
    </AppModal>
  );
};

export default ClosingChangeRequestModal;
